module.exports = __webpack_public_path__ + "static/media/009-stem cells.5d2b1d3c.svg";